import {
  ChangeDetectionStrategy, Component,
  OnInit, ViewChild
} from '@angular/core';
import { select, Store } from '@ngrx/store';

import { selectAllPaises } from '../../../../ubicaciones/entity-paises/entity-paises.selectors';
import { State } from '../../../../vista-usuario/vista-usuario.state';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';

import {
  TipoRol, TipoTecnico
} from '@rpe/registro-personas-empresas-lib';


import { combineLatest, Observable } from 'rxjs';

import { Tecnico } from '../../../entity-tecnicos/entity-tecnicos.model';
import { selectAuthTecnicos } from '../../../entity-tecnicos/entity-tecnicos.selectors';
import { NuevoVinculoFormComponent } from '../../../nuevo-vinculo-form/nuevo-vinculo-form.component';
import { NuevoVinculoFormInput } from '../../roles.model';
import { RPERolActividades } from '../../../rpe-rol-actividades/rpe-rol-actividades.model';
import { selectAllActividades } from '../../../../actividades/entity-actividades/entity-actividades.selectors';
import { selectAllTiposActividad } from '../../../../actividades/entity-tipos-actividad/entity-tipos-actividad.selectors';
import { selectAllTiposDocumento } from '../../../../persona/entity-tipos-documento/entity-tipos-documento.selectors';
import { selectAllTiposTecnico } from '../../../../persona/entity-tipos-tecnico/entity-tipos-tecnico.selectors';
import { entityRPERolActividadesAddRequest } from '../../../entity-rpe-rol-actividades/entity-rpe-rol-actividades.actions';
import { selectAllTiposRol } from '../../../entity-tipos-rol/entity-tipos-rol.selectors';
import { selectAllPaisesDocumento } from '../../../../ubicaciones/entity-paises-documento/paises-documento.selectors';


@Component({
  selector: 'rpe-entity-rol-form-container',
  templateUrl: './entity-rol-form-container.component.html',
  styleUrls: ['./entity-rol-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityRolFormContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  @ViewChild(NuevoVinculoFormComponent)
  nuevoVinculoFormComponent: NuevoVinculoFormComponent;

  formValid = false;
  formValue: RPERolActividades;

  formInput: NuevoVinculoFormInput = {
    actividad_con_nombre: [],
    tipos_rol: [],
    paises: [],
    tipos_documento: [],
    actividades: [],
    tiposActividad: [],
    paises_documento: null
  };

  tecnicoTipoRol$: Observable<[Tecnico[], TipoTecnico[], TipoRol[]]>

  constructor(
    public store: Store<State>    
  ) {}

  ngOnInit(): void {
    this.formInput = {
      actividad_con_nombre: [],
      tipos_rol: [],
      paises: [],
      tipos_documento: [],
      actividades: [],
      tiposActividad: [],
      paises_documento: null
    };

    this.tecnicoTipoRol$ = combineLatest([
      this.store.select(selectAuthTecnicos),
      this.store.select(selectAllTiposTecnico),
      this.store.select(selectAllTiposRol),
    ]);
    this.tecnicoTipoRol$.subscribe(([tecnicos, tiposTecnicos, tiposRol])=>{
      if (tecnicos){
        const auxTiposRol: TipoRol[] = [];
        let auxTT: TipoTecnico;
        let auxTR: TipoRol;
        tecnicos.forEach((tecnico) => {
          auxTT = tiposTecnicos.find(
            (tt) => tt.id == tecnico.tipo_tecnico_id && tecnico.habilitado == 2 // esta habilitado
          );
          if (auxTT) {
            if (auxTT.id == 1) {
              // es tecnico responsable
              if (tecnico.acreditado == 3) {
                // esta acreditado
                auxTR = tiposRol.find((tr) => tr.id == 6);
              } else {
                auxTR = tiposRol.find((tr) => tr.id == 5);
              }
            } else if (auxTT.id == 3) {
              // muestreador
              auxTR = tiposRol.find((tr) => tr.id == 7);
            }
          }
          if (auxTR && !auxTiposRol.includes(auxTR)) {
            auxTiposRol.push(auxTR);
          }
        });
        this.formInput = {
          actividad_con_nombre: [],
          tipos_rol: auxTiposRol,
          paises: [],
          tipos_documento: [],
          actividades: [],
          tiposActividad: [],
          paises_documento: []
        };
      }
    });  

    this.store.pipe(select(selectAllPaises)).subscribe((paises) => {
      this.formInput = {
        ...this.formInput,
        paises: paises
      };
    });

    this.store.pipe(select(selectAllTiposDocumento)).subscribe(
      (tiposDocumento) =>
        (this.formInput = {
          ...this.formInput,
          tipos_documento: tiposDocumento
        })
    );

    this.store.pipe(select(selectAllActividades)).subscribe(
      (actividades) =>
        (this.formInput = {
          ...this.formInput,
          actividades: actividades
        })
    );

    this.store.pipe(select(selectAllTiposActividad)).subscribe(
      (tiposActividad) =>
        this.formInput = {
          ...this.formInput,
          tiposActividad: tiposActividad
        }
    );

    this.store.pipe(select(selectAllPaisesDocumento)).subscribe(
      paisesDocuemento => this.formInput = {
        ...this.formInput,
        paises_documento: paisesDocuemento
      }
    )
    
  }

  formStatusChanges(status: any) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(rpeRolActividades: any) {
    // if (
    //   (this.formValue == null ||
    //     this.formValue.tecnico.direccion_geografica.direccion !=
    //       muestreador.tecnico.direccion_geografica.direccion) &&
    //   muestreador.tecnico.direccion_geografica.direccion?.length >= 4
    // ) {
    //   this.store.dispatch(
    //     entityDireccionesGeograficaIDELoadRequest({
    //       q: muestreador.tecnico.direccion_geografica.direccion
    //     })
    //   );
    // }
    //
    // if (
    //   this.formValue == null ||
    //   this.formValue.tecnico.direccion_geografica.departamento_codigo !=
    //     muestreador.tecnico.direccion_geografica.departamento_codigo
    // ) {
    //   this.store.dispatch(
    //     entityLocalidadesLoadRequest({
    //       q: muestreador.tecnico.direccion_geografica.departamento_codigo
    //     })
    //   );
    // }
    this.formValue = rpeRolActividades;
  }

  onSubmit() {

    if (this.formValid) {
      // if (this.formInput.action === FormActionType.Add) {
      this.store.dispatch(
        entityRPERolActividadesAddRequest({
          item: this.formValue
        })
      );
      // }
    } else {
      this.nuevoVinculoFormComponent.onShowErrors();
    }
  }

  onCancel() {
    window.location.href = '/';
  }

  onFormSubmit(evt: any) {
    this.onSubmit();
  }
}
